import CustomForm from '@components/components/CmsComponents/components/CmsContactForm/components/CustomForm/CustomForm';
import React from 'react';

const CmsContactForm = ({ contact, headingLevel = 2 }) => {
  if (!contact) {
    return null;
  }

  const { template } = contact;

  if (!template) {
    return null;
  }

  switch (template) {
    case 'custom':
      return <CustomForm contact={contact} headingLevel={headingLevel} />;
    case 'default':
    default:
      return null;
  }
};

export default CmsContactForm;
